export class PaymentRequest {
    paymentToken: string;
}
